module.exports = __webpack_public_path__ + "static/img/title_cn@2x.a6786a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/UID/title_cn@2x.png
// module id = 7a5k
// module chunks = 1